module.exports = __webpack_public_path__ + "img/杜宾-3.81e5019c.jpg";